<template>
  <div class="header-box">
      <header class="w" >
        <div class="w-box">
          <div>
            <h1 @click="changePage(-1)">
              <router-link to="/" title="净空老法师專集">净空老法师專集</router-link>
            </h1>
          </div>
          <div class="right-box">
            <div class="nav-list">
              <a href='/blog/archives/211' target='_self'>App下載</a>
              <a href='https://www.chinkung.org/' target='_self'>English</a>
                <el-input  placeholder="淨空老法師圖文檢索中心" @change="searchBlur" size="small" style="width: 240px;" maxlength="20" v-model="input">
                  <el-button slot="append" icon="el-icon-search" @click="searchBtn"></el-button>
                </el-input>
            </div>
          </div>
        </div>
      </header>
      <slot name="nav">

        <div class="nav-sub"  :class="{fixed:st}">
          <el-row>
            <el-col :push="1" :xs="23" :sm="23" :md="20" :lg="16":xl="14" class="mymenu">
              <div class="w">
                <i @click="drawer = !drawer" class="iconfont icon-menu" :style="mbMenu"></i>
                <el-menu :default-active="$route.name" :style="wdMenu"
                         background-color="#dcf0f4" text-color="#000000" active-text-color="#409EFF" class="head-el-menu" router mode="horizontal" @select="handleSelect">
                  <el-submenu index="home">
                    <template slot="title">
                      <a href='/' target='_self'>首頁</a>
                    </template>
                    <el-menu-item index="https://www.amtb.tw/" key="https://www.amtb.tw/">專集網站
                    </el-menu-item>
                    <el-menu-item index="https://www.amtb.cn/" key="https://www.amtb.cn/">大陸站
                    </el-menu-item>
                    <!--<el-menu-item index="https://www1.amtb.tw" key="https://www1.amtb.tw">舊專集網站
                    </el-menu-item>
                    <el-menu-item index="https://www1.amtb.cn" key="https://www1.amtb.cn">舊大陸站
                    </el-menu-item>-->
                    <el-menu-item index="https://www.chinkung.org" key="https://www.chinkung.org">English
                    </el-menu-item>
                  </el-submenu>
                  <el-menu-item index="livetv">直播台</el-menu-item>
                  <el-menu-item index="lectureroom">影音報恩講堂</el-menu-item>
                  <el-menu-item index="ebooklist">講記著作</el-menu-item>
                  <el-submenu index="4">
                    <template slot="title">墨寶卡片</template>
                    <el-menu-item index="moIndex">墨寶</el-menu-item>
                    <el-menu-item index="deskIndex">卡片</el-menu-item>
                  </el-submenu>
                  <el-menu-item index="5">
                    <a href='/blog/' target='_self' style="color: #000000">法音宣流</a>
                  </el-menu-item>
                  <el-menu-item index="6">
                    <a href='/blog/archives/4416' target='_self' style="color: #000000">世界淨宗</a>
                  </el-menu-item>
                </el-menu>
              </div>
            </el-col>
          </el-row>
        </div>
      </slot>
    <el-drawer class="left-drawer"
      title="關閉"
      size="75%"
      :visible.sync="drawer"
      :direction="direction"
      :with-header=true
      :before-close="handleClose" >
      <div slot="title"><i class="el-icon-info"></i>關閉</div>
      <div class="left-scroll">

      <el-menu background-color="#fafafa" :unique-opened="true" text-color="#000000" active-text-color="#409EFF" class="left-el-menu" router mode="vertical" @select="handleSelect">
        <el-submenu index="home" class="head-sub-menu">
          <template slot="title">
            <a href='/' target='_self'>首頁</a>
          </template>
          <el-menu-item index="https://www.amtb.tw/" key="https://www.amtb.tw/">專集網站
          </el-menu-item>
          <el-menu-item index="https://www.amtb.cn/" key="https://www.amtb.cn/">大陸站
          </el-menu-item>
          <!--<el-menu-item index="https://www1.amtb.tw" key="https://www1.amtb.tw">舊專集網站
          </el-menu-item>
          <el-menu-item index="https://www1.amtb.cn" key="https://www1.amtb.cn">舊大陸站
          </el-menu-item>-->
          <el-menu-item index="https://www.chinkung.org" key="https://www.chinkung.org">English
          </el-menu-item>
        </el-submenu>
        <el-menu-item index="livetv" @click="drawer = !drawer">直播台</el-menu-item>
        <el-menu-item index="lectureroom" @click="drawer = !drawer">影音報恩講堂</el-menu-item>
        <el-menu-item index="ebooklist" @click="drawer = !drawer">講記著作</el-menu-item>
        <el-submenu index="4">
          <template slot="title">墨寶卡片</template>
          <el-menu-item index="moIndex" @click="drawer = !drawer">墨寶</el-menu-item>
          <el-menu-item index="deskIndex" @click="drawer = !drawer">卡片</el-menu-item>
        </el-submenu>
        <el-menu-item index="5"><a href='/blog/' target='_self' style="color: #000000">法音宣流</a></el-menu-item>
        <el-menu-item index="6"><a href='/blog/archives/4416' target='_self' style="color: #000000">世界淨宗</a></el-menu-item>
      </el-menu>
      </div>
    </el-drawer>
  </div>
</template>
<script>
  import YButton from '/components/YButton'
  import { mapMutations } from 'vuex'
  // import store from '../store/'
  import 'element-ui/lib/theme-chalk/index.css'
  export default{
    data () {
      return {
        mbMenu: {},
        wdMenu: {},
        wdtWidth: 780,
        drawer: false,
        direction: 'rtl',
        // 查询数据库的商品
        st: false,
        activeIndex: '1',
        activeIndex2: '1',
        // 头部购物车显示
        cartShow: false,
        positionL: 0,
        positionT: 0,
        timerCartShow: null, // 定时隐藏购物车
        input: '',
        choosePage: -1,
        searchResults: [],
        timeout: null,
        token: '',
        navList: []
      }
    },
    computed: {
    },
    methods: {
      ...mapMutations(['ADD_CART', 'INIT_BUYCART', 'ADD_ANIMATION', 'SHOW_CART', 'REDUCE_CART', 'RECORD_USERINFO', 'EDIT_CART']),
      handleIconClick (ev) {
        if (this.$route.path === '/search') {
          this.$router.push({
            path: '/refreshsearch',
            query: {
              key: this.input
            }
          })
        } else {
          this.$router.push({
            path: '/search',
            query: {
              key: this.input
            }
          })
        }
      },
      searchBlur (e) {
        let URL = 'https://ft.amtb.tw/index.php'
        let PARAMS = {query: this.input}
        let target = '_self'
        var tempForm = document.createElement('form')
        tempForm.action = URL
        tempForm.target = target
        tempForm.method = 'post'
        tempForm.style.display = 'none'
        for (let x in PARAMS) {
          let opt = document.createElement('textarea')
          opt.name = x
          opt.value = PARAMS[x]
          tempForm.appendChild(opt)
        }
        document.body.appendChild(tempForm)
        tempForm.submit()
        document.body.removeChild(tempForm)
      },
      handleClose (done) {
        done()
      },
      showError (m) {
        this.$message.error({
          message: m
        })
      },
      // 导航栏文字样式改变
      changePage (v) {
        this.choosePage = v
      },
      handleSelect (key, keyPath) {
        console.log(key, keyPath)
        if (keyPath[0] === 'home') {
          window.open(key, '_self')
        }
      },
      searchBtn () {
        let URL = 'https://ft.amtb.tw/index.php'
        let PARAMS = {query: this.input}
        let target = '_self'
        var tempForm = document.createElement('form')
        tempForm.action = URL
        tempForm.target = target
        tempForm.method = 'post'
        tempForm.style.display = 'none'
        for (let x in PARAMS) {
          let opt = document.createElement('textarea')
          opt.name = x
          opt.value = PARAMS[x]
          tempForm.appendChild(opt)
        }
        document.body.appendChild(tempForm)
        tempForm.submit()
        document.body.removeChild(tempForm)
      },
      navFixed () {
        var st = document.documentElement.scrollTop || document.body.scrollTop
        st >= 100 ? this.st = true : this.st = false
      },
      resizeMenu () {
        window.screenWidth = document.body.clientWidth
        this.wdtWidth = window.screenWidth
      }
    },
    mounted () {
      window.addEventListener('scroll', this.navFixed)
      window.addEventListener('resize', this.resizeMenu)
      this.wdtWidth = `${document.documentElement.clientWidth}`
    },
    watch: {
      wdtWidth (wd) {
        if (wd < 780) {
          this.wdMenu = {
            display: 'none'
          }
          this.mbMenu = {
            display: 'inline'
          }
        } else {
          this.wdMenu = {
            display: 'block'
          }
          this.mbMenu = {
            display: 'none'
          }
        }
      }
    },
    activated () {
      if (typeof (this.$route.query.key) !== undefined) {
        this.input = this.$route.query.key
      }
    },
    components: {
      YButton
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../assets/style/theme";
  @import "../assets/style/mixin";



  .header-box {
    background: $head-bgc;
    background-image: -webkit-linear-gradient(#fff, #fff);
    background-image: linear-gradient(#fff, #fff);
    width: 100%;
    &.fixed {
      position: fixed;
      z-index: 21;
      top: 0;
      left: 0;
      right: 0;
      border-bottom: 1px solid #dadada;
    }

  }

  header {
    height: 100px;
    z-index: 30;
    position: relative;
  }
  .w{
    width: 100%;
    height: 100%;
    margin-left: 10px;
  }
  .w-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    height: 100%;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    // position: relative;
    h1 {
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      > a {
        background: url(/static/images/global-logo.png) no-repeat 0 50%;
        background-size: cover;
        display: block;
        @include wh(230px, 50px);
        text-indent: -9999px;
        background-position: top left;
      }
    }
    .nav-list {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      flex-wrap: wrap;
      margin-right: 10px;
      .el-autocomplete{
        width: 100px;
      }
      a {
        width: 110px;
        color: #7c7c7c;
        font-size: 15px;
        &:hover {
          color: #5683EA;
        }
      }
      a:nth-child(2){
        // width: 5vw;
        margin-left: -10px;
      }
      // a:nth-child(3){
      //   width: 5vw;
      // }
    }


    .right-box {
      display: flex;
    }
    .nav-aside {
      display: flex;
      align-items: center;
    }
  }

  @media (max-device-width: 780px) {
    .head-el-menu{
      display: none;
    }
  }
  @media (max-height: 780px) {
    .nav-cart-items {
      max-height: 423px !important;
    }
  }

  @media (max-height: 900px) {
    .nav-cart-items {
      max-height: 544px !important;
    }
  }

  @media (max-height: 1080px) {
    .nav-cart-items {
      max-height: 620px !important;
    }
  }


  @media (min-width: 1px) {
    .nav-sub .nav-sub-wrapper:after {
      display: block;
    }
  }
  .nav-sub {
    position: relative;
    z-index: 20;
    height: 60px;
    background: #dcf0f4;
    box-shadow: 0 4px 4px #c5c5c5;
    &.fixed {
      position: fixed;
      z-index: 99;
      height: 60px;
      top: 0;
      left: 0;
      right: 0;
      border-bottom: 1px solid #dadada;
      background-image: -webkit-linear-gradient(#fff, #f1f1f1);
      background-image: linear-gradient(#dcf0f4, #dcf0f4);
      a{
        color: #000000;
      }
    }
    .w {
      display: flex;
      flex-direction: row-reverse;
      align-items:flex-start;
      justify-content: space-between;
      a{
        color: #000000;
      }
    }
  .head-el-menu{
    background: #D9EBF1;
    color: #4D4D4D;
    height: 50px;
    font-size: 17px;
    letter-spacing: 1.5px;
  }
    .head-sub-menu{
    background: #D9EBF1;
    color: #4D4D4D;
    font-size: 17px;
      letter-spacing: 1.5px;
  }
  }
  .left-el-menu{
    margin-top: 60px;
    font-size: 17px;
    letter-spacing: 1.5px;
    a{
      color: #000000;
    }
  }
  .left-drawer{
    font-size: 14px;

  }
  .left-scroll{
    overflow: scroll;
    background-color: #fafafa;
    height:calc(100vh);
  }
  .head-sub-menu{
  }
  .el-icon-s-unfold{
    height: 50px;
    width: 50px;
    margin: 5px 5px 5px 5px;
    padding: 12px 0 10px 0;
    text-align: center;
    font-size: 1.8rem;
  }
  .mymenu{
    display: flex;
    display: -webkit-flex;
    display: -moz-flex;
    flex-direction: row-reverse;
    justify-content: flex-start;
    align-items: flex-start;
  }
</style>




// WEBPACK FOOTER //
// header.vue?0683ebb2